module.exports = __webpack_public_path__ + "static/media/mail_letter.ae0b7a2e.jpg";